import { Api } from '../axiosApi';

export type CategoriaCotacao = 'moeda' | 'commodity' | 'indice' | 'indicador' | 'combustivel';

export interface ICotacao {
  codigo: string;
  nome: string;
  categoria: CategoriaCotacao;
  valor: number;
  unidade: string;
  valorBRL?: number;
  unidadeBRL?: string;
  variacao: number | null;
  historico: number[];
  fonte: string;
  referencia?: string;
}

export interface ICotacoesMercado {
  atualizadoEm: string;
  itens: ICotacao[];
}

export interface INoticiaMercado {
  titulo: string;
  resumo: string;
  link: string;
  imagem?: string;
  publicadoEm: string;
  fonte: string;
  categoria: 'geral' | 'tributario';
}

const mensagemDeErro = (error: unknown, padrao: string) => {
  const resposta = (error as { response?: { data?: { errors?: { default?: string } } } }).response;
  return resposta?.data?.errors?.default || (error as { message?: string }).message || padrao;
};

// Cotações e notícias vêm do backend (/mercado/*), que busca as fontes
// externas e guarda em cache — o navegador não consegue ler a maioria delas
// direto (CORS), e assim cada usuário não bate nas fontes separadamente.
const getCotacoes = async (): Promise<ICotacoesMercado | Error> => {
  try {
    const { data } = await Api.get('/mercado/cotacoes');
    if (data) return data;
    return new Error('Cotações indisponíveis no momento.');
  } catch (error) {
    return new Error(mensagemDeErro(error, 'Cotações indisponíveis no momento.'));
  }
};

const getNoticias = async (): Promise<INoticiaMercado[] | Error> => {
  try {
    const { data } = await Api.get('/mercado/noticias');
    if (Array.isArray(data)) return data;
    return new Error('Notícias indisponíveis no momento.');
  } catch (error) {
    return new Error(mensagemDeErro(error, 'Notícias indisponíveis no momento.'));
  }
};

export const MercadoService = {
  getCotacoes,
  getNoticias,
};
